import { createSelector } from "reselect";

const getAmpAnnotation = (state) =>
  state.variantResult && state.variantResult.amp_annotation;

const getAcmgAnnotationGene = (state) =>
  state.variantResult &&
  state.variantResult.acmg_annotation &&
  state.variantResult.acmg_annotation.gene_symbol;

const getAmpClassifications = createSelector(
  getAmpAnnotation,
  (variantResults) => variantResults && variantResults.classifications
);

const getAMPSOMARule = createSelector(getAmpAnnotation, (variantResults) => {
  if (variantResults && variantResults.classifications) {
    const SOMARule = variantResults.classifications.filter(
      (classification) => classification.name === "Soma"
    );
    if (
      SOMARule &&
      Array.isArray(SOMARule) &&
      SOMARule.length > 0 &&
      SOMARule[0].tier
    ) {
      return SOMARule[0].tier;
    }
  }
  return null;
});

const getAmpVerdict = createSelector(
  getAmpAnnotation,
  (variantResults) => variantResults && variantResults.verdict
);

const getAmpErrors = createSelector(
  getAmpAnnotation,
  (variantResults) => variantResults && variantResults.errors
);

const getAmpVersion = createSelector(
  getAmpAnnotation,
  (variantResults) => variantResults && variantResults.version_name
);

const getAmpSampleFindings = createSelector(
  getAmpAnnotation,
  (variantResults) => variantResults && variantResults.sample_findings
);

const getApprovedTherapies = createSelector(
  getAmpAnnotation,
  (variantResults) => variantResults && variantResults.approved_therapies
);

const getGeneSymbol = (state) =>
  state.variantResult && state.variantResult?.mainTranscript?.gene_symbol;

const getHgvsP1 = (state) =>
  state.variantResult && state.variantResult?.mainTranscript?.hgvs_p1;

const getAMPThrottling = (state) =>
  state?.variantResult?.amp_annotation?.throttling_info;

export {
  getAmpClassifications,
  getAmpVerdict,
  getAmpErrors,
  getAmpVersion,
  getAmpSampleFindings,
  getAcmgAnnotationGene,
  getAMPSOMARule,
  getApprovedTherapies,
  getGeneSymbol,
  getHgvsP1,
  getAMPThrottling,
};
